const e = {
  name: "TwoArrowsDown",
  dimensions: { width: 41, height: 40 },
  content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.29289 0.295823C1.68342 -0.0947014 2.31658 -0.0947014 2.70711 0.295823L21 18.5887L39.2929 0.295823C39.6834 -0.0947014 40.3166 -0.0947014 40.7071 0.295823C41.0976 0.686347 41.0976 1.31951 40.7071 1.71004L21.7071 20.71C21.3166 21.1006 20.6834 21.1006 20.2929 20.71L1.29289 1.71004C0.902369 1.31951 0.902369 0.686347 1.29289 0.295823Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.29289 19.2958C1.68342 18.9053 2.31658 18.9053 2.70711 19.2958L21 37.5887L39.2929 19.2958C39.6834 18.9053 40.3166 18.9053 40.7071 19.2958C41.0976 19.6863 41.0976 20.3195 40.7071 20.71L21.7071 39.71C21.3166 40.1006 20.6834 40.1006 20.2929 39.71L1.29289 20.71C0.902369 20.3195 0.902369 19.6863 1.29289 19.2958Z" fill="currentColor"/>
  `
};
export {
  e as TwoArrowsDown
};
